<template>
  <section class="row">
    <div class="col-12 col-lg-9 mx-auto">
      <v-radio
        input-id="option-cyber"
        label="Sélectionnez votre niveau de protection"
        :list="options"
        path="extensions"
        module-name="contract"
        getter-name="get"
        :getter-function="getFormula"
        setter-name="updateSubscription"
        :setter-function="setRadioSubscription"
        :input-disabled="disabled"
      />
      <div class="d-flex flex-md-row flex-column flex-wrap mb-2 mb-md-4">
        <div
          class="d-flex flex-column col-12 offset-md-4"
        >
          <span
            v-for="(perk, index) in perksList"
            :key="perk"
            :class="(index >= 3 && formule === 'BASIC')
              || (index >= 5 && formule === 'CONFORT')
              || (index >= 7 && formule === 'PREMIUM')
              ? 'text-gray-400' : ''"
          >
            <font-awesome-icon
              :icon="['fas', (index >= 3 && formule === 'BASIC')
                || (index >= 5 && formule === 'CONFORT')
                || (index >= 7 && formule === 'PREMIUM')
                ? 'times' : 'check']"
              :class="`text-${(index >= 3 && formule === 'BASIC')
                || (index >= 5 && formule === 'CONFORT')
                || (index >= 7 && formule === 'PREMIUM')
                ? 'gray-400' : 'blue-500'}`"
              style="width: 16px"
            />
            {{ perk }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

import Radio from '@/components/common/input/Radio2.vue';

const extensionCyberID = 27;

export default {
  name: 'CustomisableCyber',
  components: {
    'v-radio': Radio,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [
        { name: 'Basic', value: 'BASIC' },
        { name: 'Confort', value: 'CONFORT' },
        { name: 'Premium', value: 'PREMIUM' },
      ],
      perksList: [
        'Assistance',
        'Enquêtes et sanctions administratives',
        'Cyber extorsion',
        'Dommages subis et perte d’exploitation',
        'Carence des fournisseurs',
        'Dommages causés à des tiers',
        'Cyberfraude et piratage téléphonique',
      ],
    };
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    formule() {
      const cyberExtension = this.contract.extensions
        .find(({ id }) => id === extensionCyberID);
      if (cyberExtension) {
        const enabledChoice = cyberExtension.settings[0].choices
          .find(({ enabled }) => enabled);

        if (enabledChoice) {
          return enabledChoice.id;
        }
        return 'BASIC';
      }
      return 'BASIC';
    },
    extensionIndex() {
      return this.contract
        .extensions
        .findIndex(({ id: extensionId }) => extensionId === extensionCyberID);
    },
  },
  methods: {
    getFormula(subscription) {
      const extension = subscription
        .extensions.find(({ id }) => id === extensionCyberID);
      const enabledChoice = extension.settings[0]
        .choices.find(({ enabled }) => enabled);

      if (enabledChoice) {
        return enabledChoice.id;
      }
      return 'BASIC';
    },
    setRadioSubscription({ value }) {
      const cyberExtension = this.contract.extensions
        .find(({ id }) => id === extensionCyberID);
      const choices = cyberExtension
        .settings[0]
        .choices
        .map((elem) => Object.assign(elem, { enabled: elem.id === value }));
      const updatePath = `extensions[${this.extensionIndex}].settings[0].choices`;
      return { choices, updatePath };
    },
  },
};
</script>
